module.exports = __webpack_public_path__ + "img/hotelFamily-8.a8256203.jpg";